import styled from '@emotion/styled'
import { withClass } from 'common/emotion'
import { metrics } from 'component-library/__styling/settings'
import { WebLink } from 'common/navigation/web-link'
import { calcRem } from 'component-library/__styling/style-functions'

const styledPointerClassName = 'pointer'

export const StyledPointer = withClass(styledPointerClassName)(
    styled('div')({
        display: 'block',
        maxWidth: '728px',
        margin: `0 auto ${calcRem(metrics.thewest.textMargin / 2)}`,
    })
)

export const StyledPointerLink = styled(WebLink)({
    display: 'block',
})

export const StyledPointerPicture = styled('picture')({
    display: 'block',
    position: 'relative',
})

export const StyledPointerImg = styled('img')({
    width: '100%',
    height: 'auto',
    display: 'block',
    position: 'relative',
    top: 0,
    left: 0,
})
